<template>
  <v-footer
    rounded="xl"
    :class="
      color
        ? 'font-weight-medium nsecondary nwhite--text'
        : 'font-weight-medium transparent adaprimary--text'
    "
  >
    <v-col class="text-center" cols="12">
      © 2017-{{ new Date().getFullYear() }} — Versio {{ gitHash }}
      <span v-if="!isP">— NO-PROD </span>
    </v-col>
    <v-col class="text-center caption" cols="12">
      Yläreunan jouluhattu on varastettu
      <a href="https://www.flaticon.com/authors/freepik" title="Freepik">
        Freepik
      </a>
      (<a href="https://www.flaticon.com/" title="Flaticon">
        www.flaticon.com </a
      >) -sivustolta
    </v-col>
  </v-footer>
</template>

<script>
export default {
  props: {
    color: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isP() {
      return process.env.NODE_ENV === "production";
    },
    gitHash() {
      return process.env.VUE_APP_GIT_HASH || "LOCALDEV";
    },
  },
};
</script>
